import { useEffect, useRef } from "react";
import { FormRow, Switch } from "@omnabase/ui";

/** start_conversation round three (2026-10-22; brief rule 4): the back office's "Bulk sending" row, the platform's switch for the
 *  workspace's conversation tool (on by default; off, every connected AI's start_conversation there is refused bulk_sending_off). The
 *  founder's health mail links here with `?bulk=1`, which brings the row onto the screen once the page has loaded. */
export const BULK_SWITCH_LABEL = "Connected AIs may start conversations in this workspace";

export function BulkSendingRow({ on, busy, focus, onChange }: { on: boolean; busy: boolean; /** `?bulk=1`: scroll the row into view */ focus: boolean; onChange: (on: boolean) => void }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => { if (focus) ref.current?.scrollIntoView({ block: "center" }); }, [focus]);
  return (
    <div ref={ref} id="bulk-sending" className="ob-admin-bulk">
      <FormRow label="Bulk sending" help="Whether connected AIs may start conversations in this workspace (start_conversation). Only OmnaBase's administrators see or change it." inline>
        <Switch checked={on} disabled={busy} label={BULK_SWITCH_LABEL} onChange={onChange} />
      </FormRow>
    </div>
  );
}
